import { Injectable } from '@angular/core';
import { FormaDePagamento } from '../models/forma-de-pagamento';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MeioDePagamento } from '../models/meio-de-pagamento';

@Injectable({
  providedIn: 'root'
})
export class MeiosDePagamentoService {

  constructor(private http: HttpClient) {

  }

  consultar(status, preenchido, ordem, asc_desc) {
    return this.http.get<MeioDePagamento[]>(globals.apiUrl + '/api/MeiosDePagamento/Listar',
      { params: new HttpParams().set('status', status.toString()).set('preenchido', preenchido.toString()).set('ordem', ordem.toString()).set('asc_desc', asc_desc.toString()) });
  }



  salvar(meios: MeioDePagamento[]) {
    return this.http.post(globals.apiUrl + '/api/MeiosDePagamento/Salvar', { meios: meios },
      { responseType: 'text' });
  }


  // consultarPorCondicao(idCondicao) {
  //   return this.http.get<FormaDePagamento[]>(globals.apiUrl + '/api/FormaPag/ListarPorCondicao',
  //     { params: new HttpParams().set('idCondicao', idCondicao) });
  // }
}
